<template>
    <MainContent title="Registros Verifactu">
        <template v-slot:header>
            <h3 class="card-title">Registros Verifactu.</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading">
                    <b-row>
                        <b-col cols="12">
                            <ContainerTable :data="registrosVerifactu" :responsive="esMovil">
                                <b-table
                                    hover
                                    :items="registrosVerifactu"
                                    :fields="fields"
                                >
                                    <template #cell(codigo_error)="{ value }">
                                        {{ value && value !== '' ? value : '-' }}
                                    </template>
                                    <template #cell(fecha_envio)="{ value }">
                                        {{ formatDate(value) }}
                                    </template>
                                    <template #cell(xml_enviado)="{ value, item }">
                                        <Button 
                                            v-if="value"
                                            @click="showModal('xml-enviado-' + item.id)" 
                                        >
                                            Ver XML
                                        </Button>
                                        <span v-else>-</span>
                                        <ModalComponent
                                            :name="'xml-enviado-' + item.id"
                                            title="XML Enviado"
                                            @close="closeModal('xml-enviado-' + item.id)"
                                        >
                                            <pre class="bg-light p-3 rounded" style="max-height: 500px; overflow: auto; white-space: pre-wrap; word-wrap: break-word; font-size: 13px;"><code>{{ value }}</code></pre>
                                        </ModalComponent>
                                    </template>
                                    <template #cell(xml_recibido)="{ value, item }">
                                        <Button 
                                            v-if="value"
                                            @click="showModal('xml-recibido-' + item.id)" 
                                        >
                                            Ver XML
                                        </Button>
                                        <span v-else>-</span>
                                        <ModalComponent
                                            :name="'xml-recibido-' + item.id"
                                            title="XML Recibido"
                                            @close="closeModal('xml-recibido-' + item.id)"
                                        >
                                            <pre class="bg-light p-3 rounded" style="max-height: 500px; overflow: auto; white-space: pre-wrap; word-wrap: break-word; font-size: 13px;"><code>{{ value }}</code></pre>
                                        </ModalComponent>
                                    </template>                                
                                </b-table>
                            </ContainerTable>
                        </b-col>
                    </b-row>
                </div>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>
<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import apiVerifactu from '@/services/api-verifactu';
    import ModalComponent from '@/components/backend/components/ModalComponent';
    import Button from '@/components/common/Button';

    export default {
        data() {
            return {
                loading: false,
                registrosVerifactu: [],
                empresa:"70ab98d4-3656-4273-bde4-09e1c1d383ca",
            }
        },
        methods: {
            async getRegistrosVerifactu() {
                this.loading = true;
                try {
                    const response = await apiVerifactu.getRegistrosVerifactu(this.empresa);
                    this.registrosVerifactu = response.data;
                } catch (error) {
                    this.$toast.error('Error al obtener registros verifactu: ' + error.message);
                } finally {
                    this.loading = false;
                }
            },
            formatDate(dateString) {
                if (!dateString) return '-';
                return moment(dateString).format('DD-MM-YYYY HH:mm');
            },
            showModal(modalName) {
                this.$modal.show(modalName);
            },
            closeModal(modalName) {
                this.$modal.hide(modalName);
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            },
            fields() {
                return [
                    { key: 'uuid', label: 'UUID', class: 'text-center' },
                    { key: 'tipo_accion', label: 'Acción', class: 'text-center' },
                    { key: 'id', label: 'Numero', class: 'text-center' },
                    { key: 'codigo_error', label: 'Código error', class: 'text-center' },
                    { key: 'fecha_envio', label: 'Fecha envío', class: 'text-center' },
                    { key: 'resultado_global', label: 'Resultado global', class: 'text-center' },
                    { key: 'xml_enviado', label: 'xml enviado', class: 'text-center' },
                    { key: 'xml_recibido', label: 'xml recibido', class: 'text-center' },
                ];
            }
        },
        components: { 
            MainContent, ContainerTable, ModalComponent, Button
        },
        created() {
            this.getRegistrosVerifactu();
        }
    };
</script>
